import type { IMetaDataFormHook } from '../../../app/electoral-divisions/ward/utils';
import type { IWardByCode, IWardByIDState, IWardInLGAStates } from '../../../interface/state/IWardState';
import { wardType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, getFetchAPI, updateAPI, updateByIdAPI } from '../api-utils';

export const create = createAPI<IWardCreateUpdate>({
	actionType: wardType.create,
	url: '/api/v1/Ward',
});

export const get = getAPI({
	actionType: wardType.get,
	url: '/api/v1/Ward',
	type: 'core',
});

export const getByID = getByIdAPI<IWardByIDState>({
	actionType: wardType.getByID,
	url: '/api/v1/Ward',
});

export const getByCode = getFetchAPI<IWardByCode, { wardCode: string }>({
	actionType: wardType.getByCode,
	url: '/api/v1/Ward/code',
});

export const getInLGA = getFetchAPI<IWardInLGAStates, { lgaIds: number[] }>({
	actionType: wardType.getInLGA,
	url: '/api/v1/Ward/getWardsInLga',
});

export interface IWardCreateUpdate {
	id?: number;
	name: string;
	wardCode: string;
	lgaId: number;
	description: string;
	constituencyCount: number;
	pollingUnitCount: number;
}

export const update = updateAPI<undefined, IWardCreateUpdate>({
	actionType: wardType.update,
	url: '/api/v1/Ward/update',
});

export const deleteById = deleteByIdAPI({
	actionType: wardType.deleteById,
	url: '/api/v1/Ward/delete',
});

export const updateMetaData = updateByIdAPI<undefined, IMetaDataFormHook>({
	actionType: wardType.updateMetaData,
	url: '/api/v1/Ward/updatemetadata',
});
